import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { PlanSubscriptionPeriodEnum } from '../../models/enums/PlanSubscriptionPeriodEnum';
import { PlanSelection, SubscriptionPlan } from '../../models/SubscriptionPlan';
import { ConsumerSubscriptionPlanService } from '../../services/consumer-subscription-plan.service';

@Component({
  selector: 'app-subscription-plan-options',
  standalone: false,
  templateUrl: './subscription-plan-options.component.html'
})
export class SubscriptionPlanOptionsComponent implements OnInit, OnChanges, OnDestroy {
  planSubscriptionPeriodEnum = PlanSubscriptionPeriodEnum;
  @Input() billingPeriod = PlanSubscriptionPeriodEnum.MONTH;
  @Input() excludedPlanId?: number;
  @Input() loading = false;
  @Output() billingPeriodChange = new EventEmitter<PlanSubscriptionPeriodEnum>();
  @Output() selectPlan = new EventEmitter<PlanSelection>();
  plans: SubscriptionPlan[] = [];
  plansLoading = false;
  loadError = false;
  subscriptions: Subscription[] = [];
  private requestedPeriod?: PlanSubscriptionPeriodEnum;

  constructor(private service: ConsumerSubscriptionPlanService) { }

  get availablePlans(): SubscriptionPlan[] {
    return this.plans.filter(plan => plan.planId !== this.excludedPlanId);
  }

  ngOnInit(): void {
    this.loadPlans();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['billingPeriod'] && !changes['billingPeriod'].firstChange && this.billingPeriod !== this.requestedPeriod) {
      this.loadPlans();
    }
  }

  changeBillingPeriod(period: PlanSubscriptionPeriodEnum): void {
    if (period === this.billingPeriod) return;
    this.billingPeriod = period;
    this.billingPeriodChange.emit(period);
    this.loadPlans();
  }

  loadPlans(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
    this.requestedPeriod = this.billingPeriod;
    this.plans = [];
    this.plansLoading = true;
    this.loadError = false;
    this.subscriptions.push(
      this.service.listActivePlans(this.billingPeriod).subscribe(
        (data: SubscriptionPlan[]) => {
          this.plans = data ?? [];
          this.plansLoading = false;
        },
        () => {
          this.plansLoading = false;
          this.loadError = true;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
